/*
 * @Description: 球队相关 API
 * @Author: ranli
 * @Date: 2026-04-14
 */
import request from '@/utils/request'

// 获取我的球队列表
export function getMyTeams(data) {
  return request({
    url: '/api/v1/cricket/team/myTeams',
    method: 'post',
    data,
  })
}

// 根据赛事id获取我的参赛队伍列表（房间页用）
export function getMyTeamList(data) {
  return request({
    url: '/api/v1/cricket/room/listMyTeamList',
    method: 'post',
    data,
  })
}

// 获取球队详情
export function getTeamDetail(data) {
  return request({
    url: '/api/v1/cricket/room/getTeamDetail',
    method: 'post',
    data,
  })
}
// 获取比赛球员列表
export function getMatchPlayers(data) {
  return request({
    url: '/api/v1/cricket/room/listTeams',
    method: 'post',
    data,
  })
}

// 保存/创建球队
export function saveTeam(data) {
  return request({
    url: '/api/v1/cricket/room/createTeam',
    method: 'post',
    data,
    needFullLoading: true,
  })
}

// 克隆球队
export function cloneTeam(data) {
  return request({
    url: '/api/v1/cricket/team/clone',
    method: 'post',
    data,
    needFullLoading: true,
  })
}

// 删除球队
export function deleteTeam(data) {
  return request({
    url: '/api/v1/cricket/team/delete',
    method: 'post',
    data,
  })
}

// 获取球员统计信息
export function getPlayerStats(data) {
  return request({
    url: '/api/v1/cricket/player/stats',
    method: 'post',
    data,
  })
}
